import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/content";

const cols = [
  {
    title: "Solutions",
    links: [
      { label: "Commercial Electricity", path: "/solutions/commercial-electricity" },
      { label: "Commercial Natural Gas", path: "/solutions/commercial-natural-gas" },
      { label: "Virtual Power Plant Network", path: "/solutions/battery-hosting" },
      { label: "All Solutions", path: "/solutions" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", path: "/about" },
      { label: "Service Areas", path: "/service-areas" },
      { label: "Industries", path: "/industries" },
      { label: "Contact", path: "/contact" },
    ],
  },
  {
    title: "Learn",
    links: [
      { label: "Education Center", path: "/education" },
      { label: "Market Center", path: "/market-center" },
      { label: "Resources", path: "/resources" },
      { label: "Apply Online", path: "/apply" },
      { label: "Partner Portal", path: "/login" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-navy-dark text-white"
    >
      <div className="grid-texture pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-shell px-6 py-20 md:px-12 md:py-24">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img
              src="/ieg-lockup-dark.png?v=4"
              alt="Innervation Energy Group"
              className="h-16 w-auto md:h-20"
            />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
              {COMPANY.positioning}
            </p>
            <div className="mt-8 space-y-3 text-sm text-white/70">
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 text-energy" />
                {COMPANY.email}
              </a>
              <div className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-energy" />
                Serving deregulated U.S. energy markets
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-6 lg:col-start-6">
            {cols.map((col) => (
              <div key={col.title}>
                <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
                  {col.title}
                </h4>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.path}>
                      <Link
                        to={l.path}
                        className="text-sm text-white/70 transition-colors hover:text-white"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 rounded-sm border border-white/10 bg-navy-light/40 p-8 md:flex md:items-center md:justify-between">
          <div>
            <h3 className="font-heading text-xl text-white md:text-2xl">
              Ready to make smarter energy decisions?
            </h3>
            <p className="mt-2 text-sm text-white/60">
              Talk to a commercial energy advisor about your facilities.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="footer-contact-cta"
            className="mt-5 inline-flex items-center gap-2 bg-electric px-7 py-4 text-sm font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover md:mt-0"
          >
            Contact Us
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
          <p>
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="max-w-xl leading-relaxed">
            Innervation Energy Group is a commercial energy advisory firm. Service
            availability varies by state and market. Battery hosting for our Virtual
            Power Plant Network is currently evaluated in Texas and Illinois.
          </p>
        </div>
      </div>
    </footer>
  );
}
